// src/components/PendingTradesList.jsx
import React, { useCallback, useEffect, useState } from "react";
import TradeRow from "./TradeRow";
import { apiUrl } from "../config/api";
import { adminAuthHeaders } from "../utils/authHeaders";

function PendingTradesList() {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPendingTrades = useCallback(async () => {
    try {
      const response = await fetch(apiUrl("/api/trades/pending"), {
        headers: adminAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error("خطا در دریافت اطلاعات");
      }

      const data = await response.json();
      if (data.success) {
        setTrades(data.trades || []);
        setError(null);
      } else {
        setError(data.message || "خطا در سرور");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPendingTrades();
    const interval = setInterval(fetchPendingTrades, 5000);
    return () => clearInterval(interval);
  }, [fetchPendingTrades]);

  if (loading) {
    return <div className="text-center p-4">در حال بارگذاری درخواست‌ها...</div>;
  }

  if (error) {
    return <div className="text-center p-4 text-red-500">خطا: {error}</div>;
  }

  if (trades.length === 0) {
    return <div className="text-center p-4 text-gray-500">هیچ درخواست معامله‌ای در انتظار نیست.</div>;
  }

  return (
    <div>
      <div className="SelectedHeader">
        این بخش مخصوص تراکنش‌های آنی و درخواست معاملات با کاربران شماست. تمامی درخواست‌های جدید معاملات اینجا دیده می‌شود.
      </div>

      <div className="NewDealNav mt-3 grid grid-cols-8 gap-2 text-center font-bold bg-gray-100 p-2 rounded">
        <p>نام کاربر</p>
        <p>مغازه</p>
        <p>نوع معامله</p>
        <p>حالت</p>
        <p>فی (تومان)</p>
        <p>مبلغ کل</p>
        <p>مقدار ورودی</p>
        <p>اعمال</p>
      </div>

      <div className="mt-3">
        {trades.map((trade) => (
          <TradeRow key={trade.id} trade={trade} onStatusChange={fetchPendingTrades} />
        ))}
      </div>
    </div>
  );
}

export default PendingTradesList;
